import groq from 'groq'

export const faqItems = groq`
  _type,
  items[]{
    _key,
    _type,
    title,
    text
  }
`
